/*
   B26 — LE PETIT TUNISIEN (adulte) · template product.petit-tunisien-adulte
   Galerie, révélations au défilement, manifeste qui s'allume, scène du drapeau collante,
   cartes des villes qui se retournent, aide à la taille, barre d'achat, FAQ.
   Une seule boucle rAF pour tout ce qui suit le défilement (transform/opacity).
   Sans la classe « th-on » (pas d'IntersectionObserver, ou « réduire les animations ») :
   tout reste visible, rien ne bouge.
*/
(function () {
  'use strict';
  if (window.__b26th) return;
  window.__b26th = 1;

  var d = document, w = window, DE = d.documentElement, IO = 'IntersectionObserver' in w;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function clamp(v, a, b) { if (a === undefined) { a = 0; b = 1; } return v < a ? a : v > b ? b : v; }
  function restart(el, cls) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  var mqRM = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function motion() { return DE.classList.contains('th-on'); }
  function smooth() { return motion() ? 'smooth' : 'auto'; }

  /* ---------- en-tête collant du thème ---------- */
  var HDR = 0;
  function hdrH() {
    var h = $('.site-header');
    if (!h) return 0;
    var pos = w.getComputedStyle(h).position, th = w.theme && w.theme.config;
    var stk = pos === 'fixed' || pos === 'sticky' || h.classList.contains('site-header--stuck') ||
      (h.getAttribute('data-sticky') === 'true' && !(th && th.stickyHeader === false));
    return stk ? Math.min(h.offsetHeight, 120) : 0;
  }
  function setHdr() {
    var v = hdrH();
    if (v !== HDR) { HDR = v; DE.style.setProperty('--th-hdr', v + 'px'); }
  }
  function watchHdr() {
    var h = $('.site-header');
    if (h && w.MutationObserver) {
      new MutationObserver(function () { setHdr(); req(); }).observe(h, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ---------- boucle de défilement ---------- */
  var subs = [], tick = 0;
  function req() { if (!tick) tick = w.requestAnimationFrame(run); }
  function run() {
    tick = 0;
    var vh = w.innerHeight;
    for (var i = 0; i < subs.length; i++) {
      var s = subs[i];
      if (s.on || s.dirty) { s.dirty = false; s.fn(vh); }
    }
  }
  function scrub(el, fn) {
    var s = { on: !IO, dirty: true, fn: fn };
    subs.push(s);
    if (IO) {
      new IntersectionObserver(function (en) {
        s.on = en[en.length - 1].isIntersecting; s.dirty = true; req();
      }, { rootMargin: '240px 0px' }).observe(el);
    }
    return s;
  }
  function dirtyAll() { subs.forEach(function (s) { s.dirty = true; }); req(); }

  /* ---------- verrou du défilement (plein écran) ---------- */
  var lockY = 0, locks = 0;
  function lock() {
    if (locks++) return;
    lockY = w.pageYOffset || DE.scrollTop;
    var b = d.body.style;
    b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (!locks || --locks) return;
    var b = d.body.style, sb = DE.style.scrollBehavior;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    DE.style.scrollBehavior = 'auto';
    w.scrollTo(0, lockY);
    DE.style.scrollBehavior = sb;
  }

  /* ---------- photo plein écran ---------- */
  var lb = null, ICON = {
    x: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    l: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 6-6 6 6 6"/></svg>',
    r: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>'
  };
  function openLb(list, i, from) {
    if (lb || !list.length) return;
    lb = d.createElement('div');
    lb.className = 'th-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photo agrandie');
    lb.innerHTML = '<img alt="" decoding="async"><button type="button" class="th-lb__x" aria-label="Fermer">' + ICON.x + '</button>' +
      (list.length > 1 ? '<button type="button" class="th-lb__nav th-lb__nav--p" aria-label="Photo précédente">' + ICON.l +
      '</button><button type="button" class="th-lb__nav th-lb__nav--n" aria-label="Photo suivante">' + ICON.r + '</button>' : '');
    d.body.appendChild(lb);
    var img = $('img', lb), cur = i;
    function set(k) { cur = (k + list.length) % list.length; img.src = list[cur]; }
    set(i);
    lock();
    DE.classList.add('th-lb-open');
    w.requestAnimationFrame(function () { if (lb) lb.classList.add('is-on'); });
    try { history.pushState({ thlb: 1 }, ''); } catch (e) {}
    function close(fromPop) {
      if (!lb) return;
      var el = lb;
      lb = null;
      el.classList.remove('is-on');
      d.removeEventListener('keydown', key);
      w.removeEventListener('popstate', pop);
      setTimeout(function () {
        el.remove();
        unlock();
        DE.classList.remove('th-lb-open');
        if (from) { try { from.focus({ preventScroll: true }); } catch (e) {} }
      }, 260);
      if (!fromPop && history.state && history.state.thlb) history.back();
    }
    function pop() { close(true); }
    function key(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') set(cur + 1);
      else if (e.key === 'ArrowLeft') set(cur - 1);
      else if (e.key === 'Tab') {
        var f = $$('button', lb), a = d.activeElement, k = f.indexOf(a);
        e.preventDefault();
        f[(k + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    }
    w.addEventListener('popstate', pop);
    d.addEventListener('keydown', key);
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.th-lb__nav--p')) set(cur - 1);
      else if (e.target.closest('.th-lb__nav--n')) set(cur + 1);
      else if (e.target !== img || e.target.closest('.th-lb__x')) close();
    });
    var x0 = null;
    img.addEventListener('touchstart', function (e) { if (e.touches.length === 1) x0 = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) set(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
    setTimeout(function () {
      var x = lb && $('.th-lb__x', lb);
      if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    }, 60);
  }

  /* ---------- 1. galerie héros ---------- */
  function initGallery() {
    var g = $('[data-th-hero]');
    if (!g) return;
    var rail = $('[data-th-rail]', g), figs = $$('.th-hg__f', g), n = figs.length,
      cnt = $('[data-th-count]', g), bar = $('[data-th-prog]', g), cur = 0;
    if (!rail || !n) return;
    var blk = g.closest && g.closest('.product-block');
    if (blk) blk.classList.add('th-gal-block');
    function idx() {
      var c = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = 1e9;
      for (var i = 0; i < n; i++) {
        var f = figs[i], m = Math.abs(f.offsetLeft + f.offsetWidth / 2 - c);
        if (m < bd) { bd = m; best = i; }
      }
      return best;
    }
    function show(i) {
      if (i === cur) return;
      cur = i;
      if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
      if (bar) bar.style.setProperty('--g', ((i + 1) / n).toFixed(4));
    }
    var rt = 0;
    rail.addEventListener('scroll', function () {
      w.cancelAnimationFrame(rt);
      rt = w.requestAnimationFrame(function () { show(idx()); });
    }, { passive: true });
    function go(i) {
      i = (i + n) % n;
      var f = figs[i];
      rail.scrollTo({ left: f.offsetLeft - (rail.clientWidth - f.offsetWidth) / 2, behavior: smooth() });
    }
    var pv = $('[data-th-prev]', g), nx = $('[data-th-next]', g);
    if (pv) pv.addEventListener('click', function () { go(cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    var zs = $$('[data-th-zoom]', g), full = zs.map(function (z) { return z.getAttribute('data-full'); });
    zs.forEach(function (z, k) { z.addEventListener('click', function () { openLb(full, k, z); }); });
    if (cnt) cnt.textContent = '1 / ' + n;
    if (bar) bar.style.setProperty('--g', (1 / n).toFixed(4));
  }

  /* ---------- 2. révélation au défilement ---------- */
  function initReveal() {
    var els = $$('[data-th-r]');
    if (!els.length) return;
    if (!IO || !motion()) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    els.forEach(function (e) {
      var p = e.parentNode;
      p.__thi = p.__thi || 0;
      e.style.setProperty('--d', (Math.min(p.__thi, 6) * 0.08).toFixed(2) + 's');
      p.__thi++;
    });
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 3. manifeste : les mots s'allument ---------- */
  function initManifesto() {
    var s = $('[data-th-mf]');
    if (!s) return;
    var ws = $$('.th-mf__w', s), last = -1;
    scrub(s, function (vh) {
      if (!motion()) return;
      var r = s.getBoundingClientRect(),
        p = clamp((vh * 0.86 - r.top) / (r.height + vh * 0.36)),
        n = Math.round(p * ws.length);
      if (n === last) return;
      last = n;
      for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('is-lit', i < n);
    });
  }

  /* ---------- 4. scène du drapeau (collante) ---------- */
  function initFlag() {
    var sec = $('[data-th-flag]');
    if (!sec) return;
    var body = $('[data-th-flag-body]', sec), stage = $('[data-th-flag-stage]', sec),
      steps = $$('[data-th-fs]', sec), segs = $$('.th-flag__prog i', sec), n = steps.length, cur = -1, lastP = -1;
    if (!body || !stage || !n) return;
    scrub(body, function () {
      if (!motion()) return;
      var r = body.getBoundingClientRect(), len = r.height - stage.offsetHeight,
        p = len > 0 ? clamp((HDR - r.top) / len) : 0;
      if (Math.abs(p - lastP) < 4e-4) return;
      lastP = p;
      stage.style.setProperty('--p', p.toFixed(4));
      var i = Math.min(n - 1, Math.floor(p * n));
      if (i !== cur) {
        cur = i;
        steps.forEach(function (s, k) { s.classList.toggle('is-cur', k === i); });
      }
      segs.forEach(function (g, k) { g.style.setProperty('--f', clamp(p * n - k).toFixed(3)); });
    });
  }

  /* ---------- 5. parallaxe douce ---------- */
  function initParallax() {
    $$('[data-th-par]').forEach(function (el) {
      var sp = parseFloat(el.getAttribute('data-th-par')) || 0.08, host = el.parentNode;
      scrub(host, function (vh) {
        if (!motion()) { el.style.transform = ''; return; }
        var r = host.getBoundingClientRect(), c = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-c * sp).toFixed(1) + 'px,0) scale(1.14)';
      });
    });
    $$('[data-th-parx]').forEach(function (el) {
      var sp = parseFloat(el.getAttribute('data-th-parx')) || 0.12, host = el.parentNode;
      scrub(host, function (vh) {
        if (!motion()) { el.style.transform = ''; return; }
        var r = host.getBoundingClientRect(), c = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(' + (-8 + c * sp * 0.1).toFixed(2) + '%,-50%,0)';
      });
    });
  }

  /* ---------- 6. cartes des villes ---------- */
  function initCities() {
    var rail = $('[data-th-vil]');
    if (!rail) return;
    var cards = $$('[data-th-fc]', rail);
    cards.forEach(function (c) {
      var inn = $('.th-fc__in', c), front = $('.th-fc__face--f', c), back = $('[data-th-fc-back]', c);
      if (!inn || !front) return;
      front.addEventListener('click', function () {
        inn.classList.remove('is-peek');
        inn.classList.add('is-flip');
        front.setAttribute('aria-expanded', 'true');
        var lk = $('.th-fc__lk', c);
        if (lk) setTimeout(function () { try { lk.focus({ preventScroll: true }); } catch (e) {} }, 450);
      });
      if (back) back.addEventListener('click', function () {
        inn.classList.remove('is-flip');
        front.setAttribute('aria-expanded', 'false');
        try { front.focus({ preventScroll: true }); } catch (e) {}
      });
      inn.addEventListener('animationend', function () { inn.classList.remove('is-peek'); });
    });
    if (IO && cards[0]) {
      var first = $('.th-fc__in', cards[0]), io = new IntersectionObserver(function (en) {
        if (!en[en.length - 1].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { if (motion() && !first.classList.contains('is-flip')) restart(first, 'is-peek'); }, 350);
      }, { threshold: 0.75 });
      io.observe(cards[0]);
    }
  }

  /* ---------- achat : bloc du thème, taille, barre collante ---------- */
  var buySec = null, chosen = /[?&]variant=\d/.test(w.location.search), sizeHooks = [];
  function sizeInputs() { return buySec ? $$('.variant-input-wrap input', buySec) : []; }
  function curSize() { var c = buySec && $('.variant-input-wrap input:checked', buySec); return c ? c.value : ''; }
  function selectSize(v) {
    var inp = sizeInputs().filter(function (i) { return i.value === v; })[0];
    if (!inp || inp.disabled) return false;
    chosen = true;
    if (!inp.checked) {
      inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    } else sizeHooks.forEach(function (f) { f(v); });
    return true;
  }
  function jumpBuy() {
    var t = buySec && ($('.variant-input-wrap', buySec) || $('.product-single__meta', buySec)) || d.getElementById('th-acheter');
    if (!t) return;
    var y = Math.max(0, t.getBoundingClientRect().top + w.pageYOffset - HDR - 120),
      far = Math.abs(y - w.pageYOffset) > w.innerHeight * 3;
    w.scrollTo({ top: y, behavior: far || !motion() ? 'auto' : 'smooth' });
    var wrap = buySec && $('.variant-input-wrap', buySec);
    setTimeout(function () {
      restart(wrap, 'is-th-flash');
      var inp = buySec && ($('.variant-input-wrap input:checked', buySec) || $('.variant-input-wrap input', buySec));
      if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
    }, far ? 80 : 650);
  }
  function initBuy() {
    buySec = $('#MainContent .product-section');
    $$('[data-th-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); jumpBuy(); });
    });
    if (!buySec) return;
    var btn = $('.product-single__form [data-add-to-cart]', buySec) || $('.btn.add-to-cart', buySec),
      okT = 0, bar = $('[data-th-bar]'), cta = bar && $('[data-th-bar-cta]', bar), price = bar && $('[data-th-bar-price]', bar);
    function sync() {
      if (!bar) return;
      var pr = $('[data-product-price]', buySec), c = curSize();
      if (price && pr) price.textContent = (pr.textContent || '').trim();
      if (cta && !cta.classList.contains('is-busy')) {
        cta.textContent = chosen && c ? 'Ajouter · ' + c.replace('2 XL', '2XL') : 'Choisir ma taille';
      }
    }
    buySec.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('.variant-input-wrap input')) {
        if (e.isTrusted) chosen = true;
        var v = t.value;
        sizeHooks.forEach(function (f) { f(v); });
      }
      setTimeout(sync, 30);
    });
    function ok() {
      if (btn) {
        restart(btn, 'is-th-ok');
        clearTimeout(okT);
        okT = setTimeout(function () { btn.classList.remove('is-th-ok'); }, 1700);
      }
      if (cta && cta.classList.contains('is-busy')) {
        cta.classList.remove('is-busy');
        cta.textContent = '✓ Ajouté';
        setTimeout(sync, 1600);
      }
    }
    ['b11:cart-added', 'ajaxProduct:added', 'cart:item-added'].forEach(function (ev) {
      d.addEventListener(ev, function () { ok(); });
    });
    if (!bar || !btn) return;
    sync();
    if (cta) cta.addEventListener('click', function () {
      if (!chosen || btn.disabled) { jumpBuy(); return; }
      cta.classList.add('is-busy');
      setTimeout(function () { cta.classList.remove('is-busy'); sync(); }, 2500);
      btn.click();
    });
    /* la barre se range pendant la scène du drapeau, la fin de page et quand le bouton principal est visible */
    var quiet = [
      { el: $('[data-th-flag-body]'), pin: true, t: 0.5, b: 0.5 },
      { el: $('.th-end'), t: 0.88, b: 0.6 }
    ].filter(function (z) { return z.el; });
    var shown = null, liftC = null, hushC = null;
    subs.push({
      on: true, dirty: true, fn: function (vh) {
        var on = btn.getBoundingClientRect().bottom < HDR, calm = false, pin = false;
        for (var i = 0; i < quiet.length; i++) {
          var z = quiet[i];
          if (z.pin && !motion()) continue;
          var r = z.el.getBoundingClientRect();
          if (r.top < vh * z.t && r.bottom > vh * z.b) calm = true;
          if (z.pin && r.top <= HDR + 2 && r.bottom >= vh - 2) pin = true;
        }
        on = on && !calm;
        if (on !== shown) {
          shown = on;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (cta) cta.tabIndex = on ? 0 : -1;
        }
        if (on !== liftC) { liftC = on; DE.classList.toggle('th-lift', on); }
        if (pin !== hushC) { hushC = pin; DE.classList.toggle('th-hush', pin); }
      }
    });
    req();
  }

  /* ---------- 7. ta taille en deux questions ---------- */
  function initFit() {
    var f = $('[data-th-fit]');
    if (!f) return;
    var sizes = $$('[data-th-fit-size]', f), styles = $$('[data-th-fit-style]', f), res = $('[data-th-fit-res]', f),
      out = $('[data-th-fit-out]', f), why = $('[data-th-fit-why]', f), go = $('[data-th-fit-go]', f), rows = $$('[data-th-row]', f),
      pick = null, over = 0, rec = null, order = sizes.map(function (b) { return b.getAttribute('data-th-fit-size'); });
    if (!sizes.length || !res) return;
    function radio(list, el) { list.forEach(function (b) { b.setAttribute('aria-checked', b === el ? 'true' : 'false'); }); }
    function upd() {
      if (pick === null) { res.hidden = true; return; }
      var i = order.indexOf(pick), j = over ? Math.min(i + 1, order.length - 1) : i, lbl;
      rec = order[j];
      lbl = rec.replace('2 XL', '2XL');
      out.textContent = lbl;
      why.textContent = over
        ? (j === i ? 'C’est déjà la plus grande taille : il tombera droit, sans effet oversize.' : 'Une taille au-dessus de ta taille habituelle, pour un tombé large et décontracté.')
        : 'Ta taille habituelle, pour un tombé droit, ni trop près ni trop large.';
      if (go) go.textContent = 'Choisir le ' + lbl;
      res.hidden = false;
      restart(res, 'is-new');
      rows.forEach(function (r) { r.classList.toggle('is-hit', r.getAttribute('data-th-row') === rec); });
    }
    sizes.forEach(function (b) { b.addEventListener('click', function () { pick = b.getAttribute('data-th-fit-size'); radio(sizes, b); upd(); }); });
    styles.forEach(function (b) { b.addEventListener('click', function () { over = +b.getAttribute('data-th-fit-style'); radio(styles, b); upd(); }); });
    if (go) go.addEventListener('click', function () { if (rec) selectSize(rec); jumpBuy(); });
  }

  /* ---------- clavier : flèches dans les groupes de choix ---------- */
  function initRadios() {
    $$('.th-x [role="radiogroup"]').forEach(function (g) {
      g.addEventListener('keydown', function (e) {
        var k = e.key, dir = k === 'ArrowRight' || k === 'ArrowDown' ? 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? -1 : 0;
        if (!dir) return;
        var list = $$('[role="radio"]:not([disabled])', g), i = list.indexOf(d.activeElement);
        if (i < 0 || !list.length) return;
        e.preventDefault();
        var nx = list[(i + dir + list.length) % list.length];
        nx.focus();
        nx.click();
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initAcc() {
    $$('.th-x details[data-th-acc]').forEach(function (dt) {
      var sm = $('summary', dt), body = $('div', dt);
      if (!sm || !body || !body.animate) return;
      sm.addEventListener('click', function (e) {
        if (!motion()) return;
        e.preventDefault();
        var ez = 'cubic-bezier(.16,1,.3,1)';
        if (dt.open) {
          var h = body.offsetHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: ez }).onfinish = function () { dt.open = false; };
        } else {
          dt.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 380, easing: ez });
        }
      });
    });
  }

  /* ---------- démarrage ---------- */
  function relayout() { setHdr(); dirtyAll(); }
  function init() {
    DE.classList.add('th-js');
    setHdr();
    watchHdr();
    [initGallery, initReveal, initManifesto, initFlag, initParallax, initCities, initBuy, initFit, initRadios, initAcc].forEach(function (fn) {
      try { fn(); } catch (e) { if (w.console) console.warn('[petit-tunisien]', fn.name, e); }
    });
    w.addEventListener('scroll', req, { passive: true });
    var rz = 0;
    w.addEventListener('resize', function () {
      setHdr();
      req();
      clearTimeout(rz);
      rz = setTimeout(relayout, 140);
    });
    w.addEventListener('orientationchange', function () { setTimeout(relayout, 300); });
    w.addEventListener('pageshow', function (e) { if (e.persisted) relayout(); });
    if (mqRM) {
      var onRM = function () { DE.classList.toggle('th-on', !mqRM.matches && IO); setTimeout(relayout, 30); };
      if (mqRM.addEventListener) mqRM.addEventListener('change', onRM);
      else if (mqRM.addListener) mqRM.addListener(onRM);
    }
    req();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
